import React, { useEffect, useState } from 'react';
import Editor from './Editor';
import { PeoplePicker } from 'app/components/peoplePicker/PeoplePicker';
import { Label } from '@fluentui/react';
import { GraphUserDto } from 'generated/request-backend';
import EmailTeamDropdown from './emailTeamDropdown/EmailTeamDropdown';
import DOMPurify from 'dompurify';
interface IProps {
    setTitle: (title: string) => void;
    title: string;
    setContent: (title: string) => void;
    content: string;
    handleFileUploadProgress?: (loadedBytes: number, totalBytes: number) => void;
    selectedPeople: Array<GraphUserDto>;
    setSelectedPeople: (a: GraphUserDto[]) => void;
    selectedCcPeople: Array<GraphUserDto>;
    setSelectedCcPeople: (a: GraphUserDto[]) => void;
    selectedBccPeople: Array<GraphUserDto>;
    setSelectedBccPeople: (a: GraphUserDto[]) => void;
    isPreview: boolean;
    isEmail: boolean;
}

const ContentArea: React.FC<IProps> = (props: IProps) => {
    const {
        title,
        setTitle,
        content,
        setContent,
        handleFileUploadProgress,
        selectedPeople,
        setSelectedPeople,
        selectedCcPeople,
        setSelectedCcPeople,
        selectedBccPeople,
        setSelectedBccPeople,
        isPreview = false,
    } = props;

    const [showCcBcc, setShowCcBcc] = useState<boolean>(false);

    useEffect(() => {
        if (!showCcBcc) {
            setSelectedCcPeople([]);
            setSelectedBccPeople([]);
        }
    }, [showCcBcc]);

    return (
        <>
            <div className="d-flex m-b-15 m-t-20 ai-center">
                <EmailTeamDropdown isDomainSpecific={true} selectedPeople={selectedPeople} setSelectedPeople={setSelectedPeople} title="To"/>
                <PeoplePicker
                    isDomainSpecific={false}
                    selectedPeople={selectedPeople}
                    setSelectedPeople={setSelectedPeople}
                    isSingleSelect={false}
                    allowAnyMailbox
                    classNames="d-flex-grow--1"
                />
                {!showCcBcc && (
                    <button className="m-l-10 btn btn--cyan text-lineHeight--26" onClick={() => setShowCcBcc((prev) => !prev)}>
                        Cc & Bcc
                    </button>
                )}
            </div>
            {showCcBcc && (
                <>
                    <div className="d-flex m-b-15 ai-center">
                        <EmailTeamDropdown isDomainSpecific={true} selectedPeople={selectedCcPeople} setSelectedPeople={setSelectedCcPeople} title="Cc" />
                        <PeoplePicker
                            isDomainSpecific={false}
                            selectedPeople={selectedCcPeople}
                            setSelectedPeople={setSelectedCcPeople}
                            isSingleSelect={false}
                            allowAnyMailbox
                            classNames="d-flex-grow--1"
                        />
                    </div>
                    <div className="d-flex ai-center m-b-15">
                        <EmailTeamDropdown  isDomainSpecific={true} selectedPeople={selectedBccPeople} setSelectedPeople={setSelectedBccPeople} title="Bcc" />
                        <PeoplePicker
                            isDomainSpecific={false}
                            selectedPeople={selectedBccPeople}
                            setSelectedPeople={setSelectedBccPeople}
                            isSingleSelect={false}
                            allowAnyMailbox
                            classNames="d-flex-grow--1"
                        />
                    </div>
                </>
            )}
            <div className="d-flex ai-center m-b-20">
                <Label className="p-r-20">Subject:</Label>
                <input className="subject" type="text" value={title} onChange={({ target: { value } }) => setTitle(value)} />
            </div>
            {!isPreview ? (
                <Editor content={content} setContent={setContent} handleFileUploadProgress={handleFileUploadProgress} />
            ) : (
                <div className="sun-editor-editable email" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
            )}
        </>
    );
};

export default ContentArea;
